<template>
  <b-overlay
    :show="loading"
    rounded="sm"
  >
    <b-row>
      <b-col>
        <b-card title="جزئیات فعالیت">
          <b-form
            ref="activityform"
            @submit.prevent.stop
          >
            <b-row>
              <b-col
                class="mt-2"
                md="6"
                offset-md="3"
              >
                <b-row>
                  <b-col
                      class="image"
                      cols="12"
                  >
                    <fm-file-select v-model="Form.Image" label="عکس" :entity="entity" />
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                      label="کالری"
                      label-for="Calorie"
                    >
                      <b-input-group>
                        <b-input-group-prepend is-text>
                          عدد اعشاری
                        </b-input-group-prepend>
                        <cleave
                          id="Calorie"
                          v-model="Form.Calorie"
                          name="Calorie"
                          class="form-control"
                          :raw="false"
                          :options="options"
                          autocomplete="off"
                        />
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                      label="پهلو"
                      label-for="Side"
                    >
                      <v-select
                        v-model="Form.Side"
                        dir="rtl"
                        :reduce="x => x.value"
                        label="text"
                        :options="enums('ActivitySide')"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                      label="دسته بندی"
                      label-for="ActivityCategoryIds"
                    >
                      <z-activity-category v-model="Form.ActivityCategoryIds" />
                    </b-form-group>
                  </b-col>

                  <b-col md="12">
                    <b-form-group
                      label="عضله های درگیر"
                      label-for="MuscleIds"
                    >
                      <z-muscle v-model="Form.MuscleIds" />
                    </b-form-group>
                  </b-col>

                  <b-col
                    cols="12"
                    class="mt-1"
                  >
                    <b-form-group>
                      <b-form-checkbox
                        v-model="Form.Visibility"
                        name="Visibility"
                        value="true"
                        class="custom-control-success"
                      >
                        برای کاربر نمایش داده شود؟
                      </b-form-checkbox>

                      <b-form-checkbox
                        v-if="Form.Visibility === false"
                        v-model="Form.Visibility"
                        name="Visibility"
                        value="false"
                        style="display: none;"
                      />

                    </b-form-group>
                  </b-col>

                  <b-col cols="12">
                    <hr>
                  </b-col>

                  <b-col cols="12">
                    <label style="font-weight: 600;">ویدئوها</label>
                  </b-col>
                  <div
                      v-for="(item, index) in Form.ActivityVideo"
                      :key="item.Id"
                      class="px-1 mb-1"
                  >
                    <video
                        style="border-radius: 0.357rem;"
                        height="120"
                        controls
                    >
                      <source :src="item.Video">
                    </video>

                    <b-button
                        v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                        variant="outline-secondary"
                        class="btn-icon video-remove"
                        @click="removeVideo(index)"
                    >
                      <feather-icon
                          icon="XIcon"
                          size="14"
                      />
                    </b-button>
                  </div>

                  <div class="px-1 mb-1">
                  <div
                        class="activity-upload-video"
                        @click="showFmModal = true"
                    >
                      <div class="activity-upload-video-icon">
                        <feather-icon
                            size="24"
                            icon="UploadIcon"
                        />
                      </div>
                    </div>
                  </div>

                  <b-col cols="12">
                    <b-col
                        v-if="Form.ActivityVideo.length"
                        cols="auto"
                        align-self="end"
                        class="mt-3"
                    >
                      <b-button
                          variant="outline-secondary"
                          @click="setBiPBip()"
                      >
                        تنظیم bip bip
                      </b-button>
                    </b-col>
                    <b-col
                        v-if="Form.ActivityVideo.length > 0 && showBipBipSetting"
                        cols="12"
                        class="mt-1"
                    >
                      <BipBip
                          v-model="Form.Time"
                          :video="videoLink"
                      />
                    </b-col>
                  </b-col>

                  <b-col cols="12">
                    <b-row
                      v-for="(item, index) in Form.ActivityLanguage"
                      :key="index"
                    >
                      <b-col cols="12">
                        <hr>
                      </b-col>

                      <b-col md="5">
                        <b-form-group label="زبان" :label-for="'Language'[index]">
                          <z-language
                            v-model="item.Language"
                            :unselectable="Form.ActivityLanguage.map(x => x.Language)"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col md="5">
                        <b-form-group
                          label="عنوان"
                          :label-for="'Title'[index]"
                        >
                          <b-form-input
                            v-model="item.Title"
                            autocomplete="off"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col
                        md="2"
                        class="mb-1"
                        style="display: flex; align-items: flex-end;"
                      >
                        <template v-if="ActivityLanguageRemoveId !== index">
                          <b-button
                            v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                            variant="outline-danger"
                            class="btn-icon rounded-circle"
                            @click="removeActivityLanguage(index)"
                          >
                            <feather-icon
                              icon="TrashIcon"
                            />
                          </b-button>
                        </template>
                        <template v-else>
                          <b-button
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            class="btn-icon rounded-circle"
                            variant="outline-primary"
                            @click="cancelActivityLanguage"
                          >
                            <feather-icon icon="XIcon" />
                          </b-button>
                          <b-button
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            class="btn-icon rounded-circle ml-1"
                            variant="outline-primary"
                            @click="confirmActivityLanguage"
                          >
                            <feather-icon icon="CheckIcon" />
                          </b-button>
                        </template>
                      </b-col>

                      <b-col cols="12">
                        <b-form-group
                          label="تگ ها"
                          :label-for="'Tag'[index]"
                        >
                          <b-form-tags
                            v-model="item.Tag"
                            placeholder=""
                          />
                        </b-form-group>
                      </b-col>

                      <b-col cols="12">
                        <b-form-group
                          label="توضیحات"
                          :label-for="'Description'[index]"
                        >
                          <div class="form-label-group">
                            <b-form-textarea
                              id="Description"
                              v-model="item.Description"
                              name="Description"
                              autocomplete="off"
                              rows="3"
                              no-resize
                            />
                          </div>
                        </b-form-group>
                      </b-col>

                    </b-row>
                  </b-col>

                  <b-col class="mt-1">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="gradient-info"
                      @click="addActivityLanguage"
                    >
                      <feather-icon
                        icon="PlusIcon"
                        class="mr-25"
                      />
                      <span>افزودن زبان</span>
                    </b-button>
                  </b-col>
                  <b-col cols="12">
                    <hr>
                  </b-col>
                  <b-col class="mt-1 mb-2 text-center">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      type="submit"
                      variant="primary"
                      class="mr-1"
                      @click="save"
                    >
                      ذخیره
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                      variant="outline-secondary"
                      @click="back"
                    >
                      بازگشت
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
    <file-manager-modal
        v-if="showFmModal"
        :show.sync="showFmModal"
        :entity="entity"
        active-type="video"
        @select="addVideo"
    />
  </b-overlay>
</template>

<script>
import ZActivityCategory from '@/tools/activitycategory.vue'
import ZMuscle from '@/tools/muscle.vue'
import UploadFile from '@/tools/uploadFile'
import BipBip from '@/tools/BipBip.vue'
import FmFileSelect from "@/views/menu/file-manager/components/fmFileSelect.vue";
import FileManagerModal from "@/views/menu/file-manager/components/fileManagerModal.vue";

export default {
  name: 'ActivityDetails',
  components: {
    UploadFile,
    ZActivityCategory,
    ZMuscle,
    BipBip,
    FmFileSelect,
    FileManagerModal
  },
  data() {
    return {
      entity: 1,
      showFmModal: false,
      Form: {
        Id: null,
        Title: null,
        Image: null,
        Calorie: null,
        ActivityCategoryIds: [],
        ActivityLanguage: [],
        MuscleIds: [],
        Side: null,
        Time: null,
        ActivityVideo: []
      },
      Video: [],
      VideoFile: [],
      options: {
        numeral: true,
        numeralThousandsGroupStyle: 'thousand',
        numeralDecimalScale: 4,
      },
      ActivityLanguageRemoveId: null,
      loading: false,
      showBipBipSetting: false,
      videoId: 0
    }
  },
  computed: {
    videoLink() {
      if (this.Form.ActivityVideo.length) {
         return this.Form.ActivityVideo[0].Video
      }
      return null
    },
  },
  created() {
    if (this.$route.params.id) {
      this.Form.Id = this.$route.params.id
      this.get()
    } else {
      this.addActivityLanguage()
    }
  },
  methods: {
    save() {
      let url = this.$route.params.id ? this.$api.activity.update : this.$api.activity.add

      this.loading = true
      this.$http.post(url, this.Form)
        .then(() => {
          this.back()
        })
        .finally(() => {
          this.loading = false
        })
    },
    get() {
      this.loading = true
      this.$http.post(
        this.$api.activity.get, {
          Id: this.Form.Id,
        },
      )
        .then(res => {
          this.loading = false
          this.Form = res.data

          if (this.Form.ActivityVideo.length) {
            this.Form.ActivityVideo = this.Form.ActivityVideo.map(item => {
              return {
                ...item,
                Duration: item.Duration || null
              }
            })
            this.videoId = this.Form.ActivityVideo.sort((a, b) => {
              return b.Id - a.Id
            })[0].Id
            this.Form.ActivityVideo.sort((a, b) => {
              return a.Sort - b.Sort
            })
          }
        })
    },
    addActivityLanguage() {
      this.Form.ActivityLanguage.push({
        Title: null, Language: null, Description: null, Tag: null,
      })
    },
    removeActivityLanguage(index) {
      this.ActivityLanguageRemoveId = index
    },
    confirmActivityLanguage() {
      this.Form.ActivityLanguage.splice(this.ActivityLanguageRemoveId, 1)
      this.ActivityLanguageRemoveId = null
    },
    cancelActivityLanguage() {
      this.ActivityLanguageRemoveId = null
    },
    removeVideo(index) {
      this.Form.ActivityVideo.splice(index, 1)
    },
    changeVideoBipBip() {
      this.showBipBipSetting = false
    },
    setBiPBip() {
      this.showBipBipSetting = !this.showBipBipSetting
    },
    addVideo(file) {
      let isExist = !this.Form.ActivityVideo.findIndex(item => item.Video === file.Path)
      if (isExist) return
      this.videoId++
      let lastItem = this.Form.ActivityVideo[this.Form.ActivityVideo.length - 1]
      this.Form.ActivityVideo.push({
        Video: file.Path,
        Duration: file.VideoDuration || null,
        Sort: lastItem ? lastItem.Sort + 1 : 0,
        Id: this.videoId
      })
    }
  },
}
</script>

<style scoped>
.image .media-body {
  align-self: flex-end;
}
</style>
